import React from "react";
import styled, { css } from "styled-components";

import WP from "WP";

import Button from "partials/Button";
import LoadingButton from "partials/LoadingButton";
import GridElement from "partials/GridElement";

import Arrow from "icons/ArrowIcon";

const MobileGuestGroup = (props) => {
  const handleOnChange = (name, dir) => {
    let value = props[name] || 0;
    if (dir === "more") {
      value++;
    } else {
      if (props[name] > 0) value--;
    }
    props.handleChange(name, value);
  };

  return (
    <Grid>
      <StyledGridElement
        roomCounter
        colStart={1}
        colEnd={4}
        rowStart={1}
        justify='start'
      >
        <span>{WP.trans.amountOfRooms}:</span>
      </StyledGridElement>
      <StyledGridElement colStart={5} colEnd={8} rowStart={1} justify='end'>
        <CounterWrapper>
          <Counter onClick={() => handleOnChange("numRooms", "less")}>
            -
          </Counter>
          <span>{props.numRooms || "0"}</span>
          <Counter onClick={() => handleOnChange("numRooms", "more")}>
            +
          </Counter>
        </CounterWrapper>
      </StyledGridElement>
      <StyledGridElement colStart={1} colEnd={4} rowStart={2} justify='start'>
        <span>{WP.trans.amountOfGuests}:</span>
      </StyledGridElement>
      <StyledGridElement colStart={5} colEnd={8} rowStart={2} justify='end'>
        <CounterWrapper>
          <Counter onClick={() => handleOnChange("numPersons", "less")}>
            -
          </Counter>
          <span>{props.numPersons || "0"}</span>
          <Counter onClick={() => handleOnChange("numPersons", "more")}>
            +
          </Counter>
        </CounterWrapper>
      </StyledGridElement>
      <StyledGridElement
        colStart={1}
        colEnd={4}
        rowStart={3}
        justify='start'
        align='end'
      >
        <span>
          {props.numRooms || "0"} {WP.trans.rooms}, {props.numPersons || "0"}{" "}
          {WP.trans.guests}
        </span>
      </StyledGridElement>
      <StyledGridElement colStart={6} colEnd={8} rowStart={3} align='end'>
        {props.submitting ? (
          <LoadingButton placeholder='SØK' />
        ) : (
          <StyledButton onClick={() => props.handleSubmit()}>
            <StyledArrow />
          </StyledButton>
        )}
      </StyledGridElement>
    </Grid>
  );
};

export default MobileGuestGroup;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr 0.33fr) 1fr;
  grid-template-rows: 3;

  background: white;
  z-index: 1000;
  position: fixed;
  padding: 40px;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 50vh;
  border-top: 1px solid ${(props) => props.theme.colors.text};

  span {
    display: block;
    ${(props) => props.theme.fonts.p}
    color: ${(props) => props.theme.colors.text};
  }
`;

const StyledGridElement = styled(GridElement)`
  ${(props) =>
    props.roomCounter &&
    css`
      margin-bottom: 30px;
    `};
`;

const CounterWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 140px;

  > span {
    align-self: center;
  }
`;

const Counter = styled.div`
  color: ${(props) => props.theme.colors.text};
  width: 37px;
  height: 37px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid ${(props) => props.theme.colors.input};
  user-select: none;

  &:hover,
  &:active {
    border: 1px solid ${(props) => props.theme.colors.text};
  }
`;

const StyledButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledArrow = styled(Arrow)`
  fill: ${(props) => props.theme.colors.negative};
`;
